import React, { Fragment, useState } from 'react';
import fp from 'lodash/fp';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactExport from 'react-export-excel';
import { ButtonToolbar, Button, Icon } from 'rsuite';
import { parseInt } from '../../../helpers/utils';
import { OUTREACH_AGGREGATE } from '../../../helpers/ReportTemplateTypes';
import ReportTemplateFormModal from '../../../containers/ReportTemplateFormModal';
import { ReadableQueryType } from '../SearchDetails';
import { QueryLabels } from '../constants';

const reduce = fp.reduce.convert({ cap: false });
const { ExcelFile } = ReactExport;
const { ExcelSheet } = ExcelFile;

function Actions({
  result,
  searchQuery,
  searchDetails,
  columnsWithLabel,
  reportName
}) {
  const [
    showReportTemplateFormModal,
    setShowReportTemplateFormModal
  ] = useState(false);

  const exportData = () => {
    const headerData = reduce(
      (columnHeaders, val, key) => [
        ...columnHeaders,
        [
          {
            value: fp.getOr(key, key, QueryLabels),
            style: { font: { bold: true } }
          },
          { value: fp.isArray(val) ? fp.join(', ', val) : val }
        ]
      ],
      []
    )({ 'Report Name': reportName, ...searchDetails });

    const resultColumns = fp.map('label', columnsWithLabel);
    const resultData = fp.map(
      each => fp.map(({ column }) => each[column], columnsWithLabel),
      result
    );
    const dataSet = [
      { columns: ['', ''], data: headerData },
      {
        xSteps: 0, // Will start putting cell with 1 empty cell on left most
        ySteps: 2, // will put space of 5 rows,
        columns: resultColumns,
        data: resultData
      }
    ];

    return dataSet;
  };

  const templateData = () => {
    const { firstTimeBy, locations, trackingMethods } = searchQuery;
    const reportType = parseInt(searchQuery.reportType);

    const file = fp.omitBy(fp.isNaN, {
      ...searchQuery,
      reportType,
      reportAs: parseInt(searchQuery.reportAs),
      reportBy: parseInt(searchQuery.reportBy),
      resultBy: parseInt(searchQuery.resultBy),
      locations: fp.map(parseInt, locations),
      trackingMethods: fp.map(parseInt, trackingMethods),
      firstTimeBy: reportType > 2 ? null : firstTimeBy
    });

    return file;
  };

  const displayReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(true);
  };

  const closeReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(false);
  };

  const reportTemplateSaved = () => {
    closeReportTemplateFormModal();
  };

  return (
    <Fragment>
      <ButtonToolbar style={{ textAlign: 'right' }}>
        <Button appearance="ghost" onClick={displayReportTemplateFormModal}>
          <Icon icon="save" /> Save As Preset
        </Button>

        <ExcelFile
          filename={`outreach_aggregate_report_${moment().format('YMMDD')}`}
          element={
            <Button appearance="ghost">
              <Icon icon="export" /> Export
            </Button>
          }
        >
          <ExcelSheet dataSet={exportData()} name="Outreach Aggregate Report" />
        </ExcelFile>
      </ButtonToolbar>
      <ReportTemplateFormModal
        fileType={OUTREACH_AGGREGATE}
        file={templateData()}
        show={showReportTemplateFormModal}
        onSubmitted={reportTemplateSaved}
        handleClose={closeReportTemplateFormModal}
      />
    </Fragment>
  );
}

export const SearchQueryType = PropTypes.shape({
  dateRange: PropTypes.arrayOf(PropTypes.string),
  locations: PropTypes.arrayOf(PropTypes.number),
  trackingMethods: PropTypes.arrayOf(PropTypes.number),
  reportType: PropTypes.number,
  reportAs: PropTypes.number,
  reportBy: PropTypes.number,
  resultBy: PropTypes.number,
  firstTimeBy: PropTypes.number
});

Actions.propTypes = {
  searchQuery: SearchQueryType.isRequired,
  searchDetails: ReadableQueryType.isRequired,
  result: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columnsWithLabel: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  reportName: PropTypes.string
};

Actions.defaultProps = {
  reportName: ''
};

export default Actions;
